import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, type TabItem } from '@/components';

type TabId = 'stammdaten' | 'mitarbeiter' | 'devices';

const TAB_IDS: TabId[] = ['stammdaten', 'mitarbeiter', 'devices'];

interface CompanyAdminTabsProps {
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
}

export function CompanyAdminTabs({
  activeTab,
  onTabChange,
}: CompanyAdminTabsProps) {
  const { t } = useTranslation();
  const tabs: TabItem<TabId>[] = useMemo(
    () => TAB_IDS.map((id) => ({ id, label: t(`companyAdmin.tabs.${id}`) })),
    [t]
  );

  return <Tabs tabs={tabs} activeTab={activeTab} onTabChange={onTabChange} className="w-full mb-4" />;
}

export type { TabId };
export function useCompanyAdminTabs(initialTab: TabId = 'stammdaten') {
  const [activeTab, setActiveTab] = useState<TabId>(initialTab);
  return { activeTab, setActiveTab };
}
